export function cardTitleBg(nodeType) {
  if (nodeType == "detour") return "#655A9D";
  if (nodeType == "logic") return "#4A7A99";
  if (nodeType == "operator") return "#b23440";
  if (nodeType == "start") return "#DE821B";
  if (nodeType == "end") return "#DE821B";
  if (nodeType == "meta") return "#7F7F1E";
  if (nodeType == "note") return "#8a7a00";
  return "#25846B";
}
